import { useState } from "react";
import SearchButton from "../../../../components/SearchButton";
import RefreshButton from "../../../../components/RefreshButton";
import { BarsArrowUpIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Disclosure } from "@headlessui/react";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useStates } from "../../hooks/useStates";
import { useAgencyFromAgencyMapping } from "../hooks/useAgencyFromAgencyMapping";
import { useEmployees } from "../../Employees/Confie/hooks/useEmployees";
import usePolicyType from "../../../Utilities/ConfigureAgreement/PolicyType/hooks/usePolicyType";
import {
  agmtGrpFilterParams,
  agmtGrpFilterValues,
  filteredAgrmtGroupData,
  isFilteredGroup,
} from "../atoms/atoms";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import SelectHookFormMulti from "../../../../components/SelectHookFormMulti";
import { useEntity } from "../hooks/useEntity";
import { useGetAllMasterLegalEntities } from "../hooks/useGetMasterLegalEntity";

const GroupFilters = ({ searchAgreement }) => {
  const [filterFields, setFilterFields] = useRecoilState(agmtGrpFilterValues);
  const [filterParams, setFilterParams] =
    useRecoilState<any>(agmtGrpFilterParams);
  const [, setFilteredAgmtData] = useRecoilState(filteredAgrmtGroupData);
  const [, setIsFiltered] = useRecoilState(isFilteredGroup);
  const user = useRecoilValue(accountAtom);

  const [allAgency, setAllAgency] = useState(false);
  const [allEntity, setAllEntity] = useState(false);
  const [allState, setAllState] = useState(false);
  const [allPolicy, setAllPolicy] = useState(false);
  const [previousSelected, setPreviousSelected] = useState([]);
  //DropDown Options
  //for All option in States
  const allOption = {
    label: "ALL",
    value: "ALL",
  };

  const { data: masterLegalEntity, isLoading: masterLegalEntityLoading } =
    useGetAllMasterLegalEntities();
  const masterLegalEntityOpt = masterLegalEntity?.map((x) => {
    return {
      label: x.entityName,
      value: x.entityId,
    };
  });

  const { data: states } = useStates();
  const stateOptions = states
    ?.map((x) => {
      return {
        label: x.state,
        value: x.state,
      };
    })
    .filter(
      (row, index, self) =>
        self.findIndex((v) => v.label === row.label) === index
    );
  const allStatesOpt = stateOptions && [allOption, ...stateOptions]; //add all option to states dropdown

  const { data: agencies } = useAgencyFromAgencyMapping();
  const agencyOptions = agencies
    ?.map((a) => {
      return {
        label: a.agencyName,
        value: a.agencyName,
      };
    })
    .filter(
      (row, index, self) =>
        self.findIndex((v) => v.label === row.label) === index
    );
  const allAgencyOpts = agencyOptions && [allOption, ...agencyOptions];
  const { data: entities, isLoading: entityLoading } = useEntity();
  const entityOptions = entities
    ?.filter((x) => x.isActive === true)
    .map((ent) => {
      return {
        label: ent.entityName,
        value: ent.entityName,
        state: ent.state,
      };
    })
    .filter(
      (row, index, self) =>
        self.findIndex((v) => v.label === row.label) === index
    );
  const allEntityOpts = entityOptions && [allOption, ...entityOptions];
  const { data: policies } = usePolicyType();
  const policyTypes = policies
    ?.filter((x) => x.isActive === true)
    .map((data) => {
      return { label: data.policyTypeName, value: data.policyTypeName };
    });

  const allPolicyOpts = policyTypes && [allOption, ...policyTypes];

  const { data: allEmployees } = useEmployees();
  const employees = allEmployees
    ?.filter(
      (x) =>
        x.status !== "Terminated" &&
        (user?.isFranchise && user?.isNonFranchise
          ? x.employeeId > 0
          : user?.isFranchise
          ? x.employeeTypeName === "Franchise"
          : x.employeeTypeName !== "Franchise")
    )
    .map((x) => {
      return {
        value: parseInt(x.employeeId),
        label: x.fullname + " - " + x.employeenumber,
      };
    });
  const paidTypeOptions = [
    { label: "As Earned", value: "As Earned" },
    { label: "As Written", value: "As Written" },
    { label: "As Collected", value: "As Collected" },
    { label: "Flat Rate", value: "Flat Rate" },
  ];
  const statusTypes = [
    { value: true, label: "Active" },
    { value: false, label: "Inactive" },
  ];
  const writingBusinessOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];
  const billingTypes = [
    { label: "Agency", value: "Agency" },
    { label: "Direct", value: "Direct" },
    { label: "Direct / Agency", value: "Direct / Agency" },
  ];

  const resetFilter = () => {
    const defaultFilters = {
      AgreementRepositoryId: [],
      AgencyList: [],
      Carrier: [],
      Commission: null,
      EntityList: [],
      EffectiveDateTo: null,
      EffectiveDateFrom: null,
      ExpirationDate: null,
      AgreementIsActive: null,
      IsFranchise: null,
      PolicyType: [],
      SalesLead: null,
      State: [],
      Billing: null,
      masterLegalEntityId: null,
      isWritingNewBusiness: null,
    };
    const defaultFilterParams = {
      AgencyList: [],
      Carrier: [],
      Commission: null,
      EntityList: [],
      EffectiveDateTo: null,
      EffectiveDateFrom: null,
      ExpirationDate: null,
      AgreementIsActive: null,
      IsFranchise: null,
      PolicyType: [],
      SalesLead: null,
      State: [],
      Billing: null,
      masterLegalEntityId: null,
      isWritingNewBusiness: null,
    };
    setFilterParams({
      AgreementRepositoryId: filterParams.AgreementRepositoryId,
      ...defaultFilterParams,
    });
    setFilterFields(defaultFilters);
    setFilteredAgmtData([]);
    setIsFiltered(false);
  };

  const handleAllSelectChange = (
    selected,
    options,
    allOption,
    allActive,
    setAllActive,
    key,
    filterParams,
    setFilterParams,
    setFilterValue
  ) => {
    let updated = selected ?? [];
    const hasAll = updated.some((x) => x.value === "ALL");
    const withoutAll = updated.filter((x) => x.value !== "ALL");

    //ALL selected
    if (hasAll) {
      const onlyAllSelected = updated.length === 1;
      const reselectingAll = withoutAll.length === previousSelected.length;

      if (onlyAllSelected || reselectingAll) {
        updated = [allOption, ...options];
        setAllActive(true);
      } else {
        updated = withoutAll;
        setAllActive(false);
      }
    }

    //ALL was active but now unchecked
    else if (allActive) {
      updated = [];
      setAllActive(false);
    }

    //Manual selection
    else if (updated.length === options.length) {
      updated = [allOption, ...options];
      setAllActive(true);
    } else {
      setAllActive(false);
    }

    //Persist state
    const values = updated.length ? updated.map((x) => x.value) : null;

    setFilterParams({
      ...filterParams,
      [key]: values,
    });

    setFilterValue((old) => ({
      ...old,
      [key]: updated.length ? updated : null,
    }));

    setPreviousSelected(updated.filter((x) => x.value !== "ALL"));
  };

  return (
    <div className="searchContainer w-1/4 bg-white">
      <div className="">
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full">
        <div>
          <Disclosure defaultOpen>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span className="whitespace-nowrap mr-4">
                    Agreement Details
                  </span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="bg-gray-100  p-3 sm:px-2 md:px-3">
                    <div className=" flex flex-col text-xs md:gap-x-4 gap-y-2">
                      <div className="w-full">
                        <SelectHookFormMulti
                          label="State"
                          secondDiv="grid grid-cols-1"
                          options={allStatesOpt}
                          value={filterFields.State}
                          onChange={(selected) => {
                            handleAllSelectChange(
                              selected,
                              stateOptions,
                              allOption,
                              allState,
                              setAllState,
                              "State",
                              filterParams,
                              setFilterParams,
                              setFilterFields
                            );
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <SelectHookFormMulti
                          label="Agency"
                          secondDiv="grid grid-cols-1"
                          options={allAgencyOpts}
                          value={filterFields.AgencyList}
                          onChange={(selected) => {
                            handleAllSelectChange(
                              selected,
                              agencyOptions,
                              allOption,
                              allAgency,
                              setAllAgency,
                              "AgencyList",
                              filterParams,
                              setFilterParams,
                              setFilterFields
                            );
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <SelectHookFormMulti
                          label="Legal Entity"
                          secondDiv="grid grid-cols-1"
                          options={allEntityOpts}
                          isLoading={entityLoading}
                          value={
                            filterFields.EntityList
                              ? filterFields.EntityList
                              : null
                          }
                          onChange={(selected) => {
                            handleAllSelectChange(
                              selected,
                              entityOptions,
                              allOption,
                              allEntity,
                              setAllEntity,
                              "EntityList",
                              filterParams,
                              setFilterParams,
                              setFilterFields
                            );
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <SelectHookFormSingle
                          label="Master Legal Entity"
                          secondDiv="grid grid-cols-1"
                          options={masterLegalEntityOpt}
                          isLoading={masterLegalEntityLoading}
                          value={
                            filterFields.masterLegalEntityId
                              ? filterFields.masterLegalEntityId
                              : null
                          }
                          onChange={(e) => {
                            setFilterParams({
                              ...filterParams,
                              masterLegalEntityId: e ? e.value : e,
                            });
                            setFilterFields((old) => {
                              return {
                                ...old,
                                masterLegalEntityId: e ? e.value : e,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <SelectHookFormSingle
                          label="Commission Paid As"
                          secondDiv="grid grid-cols-1"
                          options={paidTypeOptions}
                          value={filterFields.Commission}
                          onChange={(e) => {
                            setFilterParams({
                              ...filterParams,
                              Commission: e ? e.value : e,
                            });
                            setFilterFields((old) => {
                              return { ...old, Commission: e ? e.value : e };
                            });
                          }}
                        />
                      </div>

                      <div className="w-full">
                        <SelectHookFormMulti
                          label="Policy Type"
                          secondDiv="grid grid-cols-1"
                          options={allPolicyOpts}
                          value={filterFields.PolicyType}
                          onChange={(selected) => {
                            handleAllSelectChange(
                              selected,
                              policyTypes,
                              allOption,
                              allPolicy,
                              setAllPolicy,
                              "PolicyType",
                              filterParams,
                              setFilterParams,
                              setFilterFields
                            );
                          }}
                        />
                      </div>

                      <div className="w-full">
                        <SelectHookFormSingle
                          label="Agreement Status"
                          secondDiv="grid grid-cols-1"
                          options={statusTypes}
                          value={filterFields.AgreementIsActive}
                          onChange={(e) => {
                            setFilterParams({
                              ...filterParams,
                              AgreementIsActive: e ? e.value : e,
                            });
                            setFilterFields((old) => {
                              return {
                                ...old,
                                AgreementIsActive: e ? e.value : e,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <SelectHookFormSingle
                          label="Sales Leads"
                          secondDiv="grid grid-cols-1"
                          options={employees}
                          value={filterFields.SalesLead}
                          onChange={(e) => {
                            setFilterParams({
                              ...filterParams,
                              SalesLead: e ? e.value : e,
                            });
                            setFilterFields((old) => {
                              return { ...old, SalesLead: e ? e.value : e };
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <SelectHookFormSingle
                          label="Billing"
                          secondDiv="grid grid-cols-1"
                          options={billingTypes}
                          value={filterFields.Billing}
                          onChange={(e) => {
                            setFilterParams({
                              ...filterParams,
                              Billing: e ? e.value : e,
                            });
                            setFilterFields((old) => {
                              return { ...old, Billing: e ? e.value : e };
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <SelectHookFormSingle
                          label="Currently Writing New Business"
                          secondDiv="grid grid-cols-1"
                          options={writingBusinessOptions}
                          value={filterFields.isWritingNewBusiness}
                          onChange={(e) => {
                            setFilterParams({
                              ...filterParams,
                              isWritingNewBusiness: e ? e.value : e,
                            });
                            setFilterFields((old) => {
                              return {
                                ...old,
                                isWritingNewBusiness: e ? e.value : e,
                              };
                            });
                          }}
                        />
                      </div>

                      <div className="flex justify-center items-end gap-x-2 mb-4 rounded-md mt-5">
                        <SearchButton
                          buttonValue="Search"
                          onClick={() => searchAgreement()}
                        />
                        <RefreshButton onClick={resetFilter} />
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>
    </div>
  );
};

export default GroupFilters;
